/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IncidentProtocolFormListEntry } from './IncidentProtocolFormListEntry';
import {
    IncidentProtocolFormListEntryFromJSON,
    IncidentProtocolFormListEntryFromJSONTyped,
    IncidentProtocolFormListEntryToJSON,
} from './IncidentProtocolFormListEntry';

/**
 * 
 * @export
 * @interface FindAllProtocolForms200Response
 */
export interface FindAllProtocolForms200Response {
    /**
     * 
     * @type {Array<IncidentProtocolFormListEntry>}
     * @memberof FindAllProtocolForms200Response
     */
    data?: Array<IncidentProtocolFormListEntry>;
}

/**
 * Check if a given object implements the FindAllProtocolForms200Response interface.
 */
export function instanceOfFindAllProtocolForms200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllProtocolForms200ResponseFromJSON(json: any): FindAllProtocolForms200Response {
    return FindAllProtocolForms200ResponseFromJSONTyped(json, false);
}

export function FindAllProtocolForms200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllProtocolForms200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(IncidentProtocolFormListEntryFromJSON)),
    };
}

export function FindAllProtocolForms200ResponseToJSON(value?: FindAllProtocolForms200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(IncidentProtocolFormListEntryToJSON)),
    };
}

